import { render, staticRenderFns } from "./FragmentRelatedArticles.vue?vue&type=template&id=3db71665&scoped=true"
import script from "./FragmentRelatedArticles.vue?vue&type=script&lang=ts"
export * from "./FragmentRelatedArticles.vue?vue&type=script&lang=ts"
import style0 from "./FragmentRelatedArticles.vue?vue&type=style&index=0&id=3db71665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db71665",
  null
  
)

export default component.exports